import React, { useContext, useCallback, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap'

import { SessionContext } from '../contexts/SessionContext'
import { useUserMeta } from '../hooks/useUserMeta'
import { freeTrialRemaining } from '../data/user'
import { formatDuration } from '../data/job_invoice_item'

interface HeaderProps {
  baseUrl: string
}

const Header: React.FC<HeaderProps> = ({ baseUrl }) => {
  const session = useContext(SessionContext)

  const [ isOpen, setIsOpen ] = useState(false)
  const toggle = useCallback(
    () => {
      setIsOpen(o => !o)
    }, [setIsOpen]
  )

  const userMeta = useUserMeta()
  const transcribedMinutes = useMemo(
    () => {
      const secs = userMeta?.total_transcribe_seconds
      if (!userMeta || (!secs && secs !== 0))
        return null

      const remainingSecs = freeTrialRemaining(userMeta)
      if (remainingSecs > 0) {
        return `You have ${formatDuration(remainingSecs)} left on your free trial.`
      }
      return `You've transcribed ${formatDuration(secs)} with us. Thanks!`
    },
    [ userMeta ]
  )

  return (
    <header className="sticky-top">
      <Navbar color="light" light expand="md">
        <div className="container">
          <NavbarBrand className="h1 mb-0" tag={Link} to={baseUrl}>
            speech2
            <span className="text-muted">transcript</span>
          </NavbarBrand>

          { session.loggedIn && typeof session.user !== 'undefined' && <>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    {session.user && (session.user as any).attributes && (session.user as any).attributes.email}
                  </DropdownToggle>
                  <DropdownMenu right>
                    { transcribedMinutes &&
                      <DropdownItem disabled>
                        {transcribedMinutes}
                      </DropdownItem>
                    }
                    <DropdownItem tag={Link} to="/billing">
                      Billing
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={session.logout}>
                      Logout
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </> }
        </div>
      </Navbar>
    </header>
  )
}

export default Header
